export default (parameterIds) => {
  const PARAM_IDS = parameterIds

  return {
    1: {
      name: 'Wind Observations & Forecasts',
      shortName: 'Wind Map',
      description: 'Real-time wind reports (speed and direction). Click markers for more details.',
      overlayName: 'markers',
      analyticsName: 'Wind_Observations',
      mapMode: 'obs',
      category: 'obs',
      overlays: { markers: { data: [PARAM_IDS.paramWind], loc: [1, 100] } }
    },
    2: {
      name: 'Wind Forecast',
      description: 'Computer generated, numerical model wind forecasts.',
      overlayName: 'fx',
      analyticsName: 'Wind_Forecast',
      mapMode: 'fx',
      category: 'fx',
      forecastSelectorNeeded: true,
      overlays: {
        fx: {
          modelId: null,
          param: PARAM_IDS.paramWind,
          flowviz: false,
          showPast: true
        }
      }
    },
    3: {
      name: 'Nowcast',
      description:
        'Real-time wind estmates based on the WeatherFlow Nowcast model, which incorporates the best available observations and forecast data.',
      overlayName: 'nowcast',
      analyticsName: 'Wind_Nowcast',
      mapMode: 'obs',
      category: 'obs',
      overlays: { markers: { data: [100, 101], loc: [100] } },
      featureId: 7
    },
    10: {
      name: 'Marine Forecast',
      description:
        "Today's zone forecasts from the National Weather Service.  Click the zone to see the Forecast.",
      overlayName: 'marine-fx',
      analyticsName: 'NWS_Marine_Forecast_Zones',
      mapMode: 'obs',
      category: 'fx',
      forecastSelectorNeeded: false,
      overlays: { 'marine-fx': {} }
    },
    5: {
      name: 'Radar / Precipitation',
      description: 'High resolution radar imagery. Press play to animate.',
      overlayName: 'radar',
      analyticsName: 'Radar_Precipitation',
      mapMode: 'obs',
      category: 'obs',
      overlays: { radar: { product: 'N0Q' } }
    },
    6: {
      name: 'Satellite / Clouds',
      description: 'High resolution satellite imagery.  Press play to animate.',
      overlayName: 'satellite',
      analyticsName: 'Satellite_Clouds',
      mapMode: 'obs',
      category: 'obs',
      overlays: { satellite: {} }
    },
    7: {
      name: 'Sea Surface Temperatures',
      description: 'High resolution ocean surface temperatures.',
      overlayName: 'sst',
      analyticsName: 'Sea_Surface_Temperatures',
      mapMode: 'obs',
      category: 'obs',
      overlays: { sst: {}, 'coastal-outline': {} },
      featureId: 18
    },
    8: {
      name: 'Radar + Wind',
      description: 'High resolution radar imagery overlaid by real-time wind reports.',
      overlayName: 'radar',
      analyticsName: 'Radar_Wind',
      mapMode: 'obs',
      category: 'obs',
      overlays: {
        markers: { data: [1], loc: [1, 100] },
        radar: { product: 'N0Q' }
      }
    },
    9: {
      name: 'Satellite + Wind',
      description: 'High resolution radar imagery overlaid by real-time wind reports.',
      overlayName: 'satellite',
      analyticsName: 'Satellite_Wind',
      mapMode: 'obs',
      category: 'obs',
      overlays: { markers: { data: [1], loc: [1, 100] }, satellite: {} }
    },
    11: {
      name: 'Pro Forecasts',
      description: 'Site-specific weather briefings by our own staff of meteorologists.',
      overlayName: 'pro-forecast',
      analyticsName: 'Pro_Forecasts',
      mapMode: 'obs',
      category: 'obs',
      overlays: { 'briefing-map': {} }
    },
    12: {
      name: 'OnSite Reports',
      description:
        'Crowdsourced (user-generated) wind and weather reports, contributed by real people via different applications.',
      overlayName: 'onsite-reports',
      analyticsName: 'Onsite_Reports',
      mapMode: 'obs',
      category: 'obs',
      overlays: { 'onsite-reports': {} },
      featureId: 24
    },
    13: {
      name: 'Sea Surface Currents Forecast',
      description: 'High resolution Regional Sea Surface Currents.',
      overlayName: 'currents',
      analyticsName: 'Sea_Surface_Currents_Forecast',
      mapMode: 'fx',
      category: 'fx',
      animationControlsNeeded: true,
      forecastSelectorNeeded: true,
      overlays: { currents: {} },
      featureId: 25
    },
    14: {
      name: 'Water Level',
      description: 'Water Level',
      overlayName: 'water-level',
      analyticsName: 'Water_Level',
      mapMode: 'obs',
      category: 'obs',
      overlays: {
        markers: { data: [PARAM_IDS.paramWaterLevel], loc: [1, 100] }
      }
    },
    18: {
      name: 'Forecast FlowViz',
      description: 'Computer generated, numerical model wind forecasts.',
      overlayName: 'flow',
      analyticsName: 'Flow',
      mapMode: 'fx',
      category: 'fx',
      forecastSelectorNeeded: true,
      overlays: {
        fx: {
          modelId: null,
          param: PARAM_IDS.paramWind,
          flowviz: true,
          showPast: true
        },
        'coastal-outline': {}
      }
    },
    19: {
      name: 'Wind Observations & Gusts',
      shortName: 'Wind + Gusts',
      description:
        'Real-time wind reports (speed, gust and direction). Click markers for more details.',
      overlayName: 'gusts',
      analyticsName: 'Wind_Gust',
      mapMode: 'obs',
      category: 'obs',
      overlays: {
        markers: { data: [PARAM_IDS.paramWind], loc: [1], showGust: true }
      },
      featureId: 34
    },
    20: {
      name: 'Radar + Wind Gusts',
      description: '',
      overlayName: 'radar',
      analyticsName: 'Radar_Wind_Gusts',
      mapMode: 'obs',
      category: 'obs',
      overlays: {
        markers: { data: [PARAM_IDS.paramWind], loc: [1], showGust: true },
        radar: { product: 'N0Q' }
      }
    },
    21: {
      name: 'Lightning',
      description: '',
      overlayName: 'lightning',
      analyticsName: 'Lightning',
      mapMode: 'obs',
      category: 'obs',
      overlays: {
        lightning: {
          types: ['cg', 'ic'],
          cgCharges: ['pos', 'neg'],
          minutesOffset: 28
        }
      }
    },
    22: {
      name: 'Advisories',
      description: '',
      overlayName: 'advisories',
      analyticsName: 'Advisories',
      mapMode: 'obs',
      category: 'obs',
      overlays: { 'watches-warnings': {} }
    },
    23: {
      name: 'Wind + Radar + Satellite',
      description: '',
      overlayName: 'radar',
      analyticsName: 'Wind_Radar_Satallite',
      mapMode: 'obs',
      category: 'obs',
      overlays: {
        markers: { data: [1], loc: [1, 100] },
        radar: { product: 'N0Q' },
        satellite: {}
      }
    },
    24: {
      name: 'Wet Bulb Globe Temperature',
      description: '',
      overlayName: 'wgbt',
      analyticsName: 'Web Bulb Globe Temperature',
      mapMode: 'obs',
      category: 'obs',
      overlays: {
        // 'wet-bulb-globe-temperature': {},
        markers: {
          data: [PARAM_IDS.paramTemp],
          loc: [1],
          provider: [1046, 1047],
          overrideParam: 100
        }
      }
    },
    25: {
      name: 'Precipitation Accumulation',
      description: '',
      overlayName: 'precip-accumulation',
      analyticsName: 'Precipation_Accumulaton',
      mapMode: 'obs',
      category: 'obs',
      overlays: {
        'precip-accumulation': {
          period: 24
        }
      }
    },
    100: {
      name: 'DSAT Operating Condition',
      shortName: 'DSAT',
      overlayName: 'dsat',
      analyticsName: 'DSAT Operating Condition',
      description: '',
      mapMode: 'obs',
      category: 'obs',
      overlays: {
        'dsat-operating-condition': {},
        'watches-warnings': {
          defaultEvents: {
            'Red Flag Warning': {
              color: 'FF1493',
              count: 0,
              defaultEvent: true,
              overlay: 'dsat-operating-condition'
            }
          },
          fillOpacity: 0.5,
          strokeOpacity: 0.75
        },
        markers: { data: [PARAM_IDS.paramWind], loc: [1] }
      }
    },
    101: {
      name: 'Temperature Forecast',
      description: 'Computer generated, numerical model temperature forecasts.',
      overlayName: 'fx-temp',
      analyticsName: 'Forecast_Temperature',
      mapMode: 'fx',
      category: 'fx',
      forecastSelectorNeeded: true,
      overlays: {
        fx: {
          modelId: null,
          param: PARAM_IDS.paramTemp,
          flowviz: false,
          showPast: true
        }
      },
      regionalProductId: 2
    },
    102: {
      name: 'Pressure Forecast',
      description: 'Computer generated, numerical model pressure forecasts.',
      overlayName: 'fx-pressure',
      analyticsName: 'Forecast_Pressure',
      mapMode: 'fx',
      category: 'fx',
      forecastSelectorNeeded: true,
      overlays: {
        fx: {
          modelId: null,
          param: PARAM_IDS.paramPressure,
          flowviz: false,
          showPast: true
        }
      },
      regionalProductId: 2
    },
    103: {
      name: 'Nautical Charts + Wind',
      description: 'Nautical Charts',
      overlayName: 'nautical',
      analyticsName: 'Nautical_Wind',
      mapMode: 'obs',
      category: 'obs',
      overlays: { markers: { data: [PARAM_IDS.paramWind], loc: [1, 100] }, nautical: {} },
      featureId: 6,
      regionalProductId: 1
    },
    104: {
      name: 'Favorite Spots',
      description: 'Favorite Spots',
      overlayName: 'favorite-spots',
      analyticsName: 'Favorite_Spots',
      mapMode: 'obs',
      category: 'obs',
      featureId: 3,
      accountRequired: true,
      overlays: { markers: { data: [1, 100, 101], loc: [1, 100, 101], profileId: null } },
      regionalProductId: 1
    },
    105: {
      name: 'Live Wind',
      description: '',
      overlayName: 'live-wind', // TODO: need make icon for live wind
      analyticsName: 'Live_Wind',
      mapMode: 'fx',
      category: 'obs',
      overlays: {
        fx: {
          modelId: -1,
          param: PARAM_IDS.paramWind,
          flowviz: true,
          showPast: true,
          transparency: 0.6,
          showLastFrameBeforeFuture: true
        },
        markers: { data: [1], loc: [1, 100] }
      },
      forecastSelectorNeeded: true,
      animationControlsNeeded: false,
      timeseries: { start: 'now-past' },
      regionalProductId: 18,
      forecastMapObsMarkersOverride: true
    },
    106: {
      name: 'Humidity Forecast',
      description: 'Computer generated, numerical model pressure forecasts.',
      overlayName: 'fx-humidity',
      analyticsName: 'Forecast_Humidity',
      mapMode: 'fx',
      category: 'fx',
      forecastSelectorNeeded: true,
      overlays: {
        fx: {
          modelId: null,
          param: PARAM_IDS.paramHumidity,
          flowviz: false,
          showPast: true
        }
      },
      regionalProductId: 2
    }
  }
}